export const FTU_BOTTOMSHEET_FREQUENCY_CAP_KEY = "ftue_bottomsheet_frequency_cap";
export const BLACK_MEMBERSHIP_CROUTON_SID = "black_membership_crouton_sid";

export const CROUTON_BACKGROUND = "radial-gradient(145.85% 72.19% at 77.27% 19.01%, #390731 0%, #220419 100%)";

export const CROUTON_LOGO_DIMENTIONS = {
    width: "56",
    height: "22",
};
export const CROUTON_DURATION = 4000;

export const FTUE_HALFCARD_NR_EVENT = "FTUE_HALFCARD_NR_EVENT";
